// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"367":"872cc9a0","876":"d82699e8"}[chunkId] + ".chunk.css";
};